module.exports = __webpack_public_path__ + "static/media/description.991da8cb.svg";